export const LABEL_KEYS = {
  NUMERIC_ENTRY_BEFORE: 'numeric_entry_before',
  NUMERIC_ENTRY_AFTER: 'numeric_entry_after',
  ANSWER_CHOICE_GROUP: 'text'
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/label/label-keys.ts